<template>
  <el-form
    class="search_form"
    inline
    size="small"
    label-suffix=":"
    v-model="searchForm"
  >
    <el-form-item label="账号" prop="findParaString">
      <el-input
        class="filter"
        placeholder="请输入账号名/手机/邮箱/微信昵称"
        v-model="searchForm.findParaString"
        clearable
        @change="changeSearch"
      ></el-input>
    </el-form-item>
    <el-form-item label="企业" placeholder="请选择企业" prop="enterpriseName">
      <el-select
        class="filter"
        clearable
        v-model="searchForm.enterpriseName"
        @change="changeSearch"
      >
        <!-- <el-option label="不限" :value="-1"></el-option> -->
        <el-option
          v-for="e in enterpriseList"
          :key="e.enterpriseId"
          :label="e.enterpriseName"
          :value="e.enterpriseName"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" icon="el-icon-plus" @click="add"
        >新增账号</el-button
      >
      <el-button type="primary" icon="el-icon-plus">批量新增</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    enterpriseList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchForm: {
        enterpriseName: "",
        findParaString: "",
      },
    };
  },

  mounted() {},
  methods: {
    // 点击新增
    add() {
      //   console.log("您点击了新增账号");
      this.$emit("add-user");
    },
    changeSearch() {
      this.$emit("search-change", this.searchForm);
    },
  },
};
</script>

<style lang="scss">
.search_form {
  display: flex;
  justify-content: end;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/accManage/userSearch.vue